export default {
  namespaced: true,
  state: () => ({
    newsData: {},
  }),
  mutations: {
    setNewsData(state, payload) {
      state.newsData = payload
      if (payload.token) {
        localStorage.setItem("token", payload.token);
      }
    },
  }

}
